import * as React from "react";
import ListSubheader from "@mui/material/ListSubheader";
import HomeIcon from "../../assets/icons/home.svg";
import LeaderboardIcon from "../../assets/icons/leaderboard.svg";
import PerformanceIcon from "../../assets/icons/performance.svg";
import ProgramIcon from "../../assets/icons/program.svg";
import TeamIcon from "../../assets/icons/team.svg";

import { BrandContext } from "../../App";
import SideMenuButton from "../simple/SideMenuButton";
import { useTheme } from "@mui/material/styles";

export function MainDashboardMenu({ open, toggleMobileMenu }) {
  const theme = useTheme();
  const { user, trainingProgram } = React.useContext(BrandContext);

  return (
    <React.Fragment>
      {user && (
        <>
          <ListSubheader
            component="div"
            inset
            sx={{
              color: theme.palette.text.primary,
              display: open ? "block" : "none",
              [theme.breakpoints.up("sm")]: {},
            }}
          >
            {user.company && user.company.name}
          </ListSubheader>

          {[
            {
              to: "/",
              icon: <img src={HomeIcon} alt="Home" />,
              text: "Home",
            },
            trainingProgram?.id && {
              to: `/dashboard/trainingprogram/${trainingProgram.id}`,
              icon: <img src={ProgramIcon} alt="Programs" />,
              text: "My Programs",
            },
            {
              to: "/dashboard/simulations",
              icon: <img src={PerformanceIcon} alt="Performance" />,
              text: "Performance Spotlight",
            },
            {
              to: "/dashboard/leaderboard",
              icon: <img src={LeaderboardIcon} alt="Leaderboard" />,
              text: "Leaderboard",
            },
            {
              to: "/dashboard/team",
              icon: <img src={TeamIcon} alt="Team Icon" />,
              text: "Your Team",
            },
          ]
            .filter(Boolean)
            .map(({ to, icon, text }) => {
              const isHome = to === "/dashboard/home";
              return (
                <SideMenuButton
                  key={to}
                  to={to}
                  children={text}
                  startIcon={icon}
                  isHome={isHome}
                  open={open}
                  toggleMobileMenu={toggleMobileMenu}
                />
              );
            })}
        </>
      )}
    </React.Fragment>
  );
}
